import { Component } from '@angular/core';
import { AssetVersionPipe } from '../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-ribbon',
  imports: [AssetVersionPipe],
  templateUrl: './ribbon.component.html',
  styleUrl: './ribbon.component.scss'
})
export class RibbonComponent {

}
